import { render, staticRenderFns } from "./AccessControlDetail.vue?vue&type=template&id=5d1ad346&"
import script from "./AccessControlDetail.vue?vue&type=script&lang=js&"
export * from "./AccessControlDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports